import { ContactUsForm } from "@/@types/FormData";

export const prepareContactUsData = (formData: {
    name: string,
    lastName: string,
    company: string,
    email: string,
    phone: string, // Se recibe como string y luego se convierte a number
    state: string,
    city: string,
    from: string,
    communicationCheckbox: string,
    reCaptchaToken: string | null,
    
  }): ContactUsForm => {
    return {
      body: {
        name: formData.name,
        lasName: formData.lastName, 
        company: formData.company,
        email: formData.email,
        phone: Number(formData.phone), 
        state: formData.state,
        city: formData.city,
        from: formData.from, // Puedes modificarlo según el contexto
        communicationCheckbox:formData.communicationCheckbox
      },
      reCaptchaToken: formData.reCaptchaToken || "",
      typeForm: "contactUs",
    };
  };
  